import { shallowMount, createLocalVue } from '@vue/test-utils';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import VueRouter from 'vue-router';
import PaymentEditModal from './PaymentEditModal';

const routes = [
  { path: "/fakeroute", component: PaymentEditModal }
];

const localVue = createLocalVue();
localVue.use(Vuex);
localVue.use(Vuelidate);
localVue.use(VueRouter);

describe('PaymentEditModal', () => {
  let wrapper;
  let store;
  let router;
  let clearEditProfileFormMock;
  let saveProfileFormMock;
  let clearEditAddressFormMock;
  let hideModalMock;

  beforeEach(() => {
    saveProfileFormMock = jest.fn();
    clearEditProfileFormMock = jest.fn();
    clearEditAddressFormMock = jest.fn();
    hideModalMock = jest.fn();

    store = new Vuex.Store({
      modules: {
        payments: {
          namespaced: true,
          state: {
            editProfileForm: {}
          },

          actions: {
            saveProfileForm: saveProfileFormMock,
            clearEditProfileForm: clearEditProfileFormMock
          },

          mutations: {}
        },

        addressBook: {
          namespaced: true,
          getters: {
            paymentEditAddressValidator: jest.fn()
          },
          actions: {
            clearEditAddressForm: clearEditAddressFormMock
          }
        },

        subscriptions: {
          namespaced: true,
          actions: {
            initSubscriptions: jest.fn()
          }
        },

        modal: {
          namespaced: true,
          state: {
            visible: false
          },
          actions: {
            hideModal: hideModalMock
          }
        }
      }
    });

    router = new VueRouter({ routes });
    wrapper = shallowMount(PaymentEditModal, {
      store,
      router,
      localVue
    });
  });

  afterEach(() => {
    clearEditProfileFormMock.mockClear();
    saveProfileFormMock.mockClear();
    clearEditAddressFormMock.mockClear();
  });

  test('general snapshot', () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('computed', () => {
    describe('modalTitle', () => {
      test('return title that starts with Edit when editing existing address', () => {
        const localThis = { editProfileForm: { paymentProfileId: 234, cc_num: '1234' } };
        expect(PaymentEditModal.computed.modalTitle.call(localThis)).toEqual('Edit Payment Method');
      });

      test('return title that starts with Add when adding new address', () => {
        const localThis = { editProfileForm: { cc_num: '1234' } };
        expect(PaymentEditModal.computed.modalTitle.call(localThis)).toEqual('Add Payment Method');
      });
    });

    describe('editingAmazon', () => {
      test('return true when editProfileForm has amazon profile', () => {
        const localThis = { editProfileForm: { paymentProfileId: 123, paymentGateway: 'amazon' } };
        expect(PaymentEditModal.computed.editingAmazon.call(localThis)).toEqual(true);
      });

      test('return false when editProfileForm has paypal profile', () => {
        const localThis = { editProfileForm: { paymentProfileId: 123, paymentGateway: 'paypal' } };
        expect(PaymentEditModal.computed.editingAmazon.call(localThis)).toEqual(false);
      });
    });

    describe('editingPaypal', () => {
      test('return true when editProfileForm has paypal profile', () => {
        const localThis = { editProfileForm: { paymentProfileId: 123, paymentGateway: 'paypal' } };
        expect(PaymentEditModal.computed.editingPaypal.call(localThis)).toEqual(true);
      });

      test('return false when editProfileForm has braintree profile', () => {
        const localThis = { editProfileForm: { paymentProfileId: 123, paymentGateway: 'braintree' } };
        expect(PaymentEditModal.computed.editingPaypal.call(localThis)).toEqual(false);
      });
    });
  });

  describe('methods', () => {
    describe.skip('onSubmit', () => {});

    describe('onCancel', () => {
      test('emit hide modal event', () => {
        wrapper.vm.onCancel();
        expect(hideModalMock).toHaveBeenCalledTimes(1);
      });

      test('call cleanUp method', () => {
        let cleanUpSpy = jest.spyOn(wrapper.vm, 'cleanUp');
        wrapper.vm.onCancel();
        expect(cleanUpSpy).toHaveBeenCalledTimes(1);
      });
    });

    describe('cleanUp', () => {
      test('expected calls', () => {
        wrapper.vm.cleanUp();
        expect(clearEditAddressFormMock).toHaveBeenCalledTimes(1);
        expect(clearEditProfileFormMock).toHaveBeenCalledTimes(1);
      });

      test('clear route params', () => {
        router.push('/fakeroute?editPayment=true');
        expect(wrapper.vm.$route.query).toEqual({"editPayment": "true"});
        wrapper.vm.cleanUp();
        expect(wrapper.vm.$route.query).toEqual({});
      });
    });
  });

});